import { useRef } from "react";
import "swiper/css";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Partners.css";

import "swiper/css";
import "swiper/css/navigation";
import c7 from "../../img/Partners/BiteAmritLogo.png";
import c1 from "../../img/Partners/Nautika.png";
import c2 from "../../img/Partners/OmerAbdullaLogoT.png";
import c3 from "../../img/Partners/WelthClinic.png";
import c4 from "../../img/Partners/bharatjalpaan.png";
import c10 from "../../img/Partners/c10.jpeg";
import c12 from "../../img/Partners/c12.jpeg";
import c8 from "../../img/Partners/c8.jpeg";
import c9 from "../../img/Partners/c9.jpeg";
import c5 from "../../img/Partners/octavian.png";
import c11 from "../../img/Partners/pippy.png";
import c6 from "../../img/Partners/reemasteel.png";
import C13 from "../../img/Partners/nextLayer.png";

const clients = [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12, C13];

const Partners = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <section className="uniq-oglitz-partners">
      <div className="uniq-oglitz-partners__container">
        {/* Header */}
        <div className="uniq-oglitz-partners__header">
          <p className="uniq-oglitz-partners__eyebrow">
            Our Clients & Partners
          </p>
          <h2 className="uniq-oglitz-partners__title">
            Trusted by Businesses Worldwide
          </h2>
          <p className="uniq-oglitz-partners__subtitle">
            We collaborate with startups, enterprises, and growing brands across
            India, Dubai, and global markets.
          </p>
        </div>

        {/* Slider Wrapper (IMPORTANT) */}
        <div className="uniq-oglitz-partners__slider">
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={false} // ✅ DEFAULT ARROWS
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop
            speed={800}
            spaceBetween={28}
            slidesPerView={5}
            breakpoints={{
              0: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              1024: { slidesPerView: 5 },
            }}
            style={{
              paddingBottom: "20px",
              paddingTop: "20px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
            className="uniq-oglitz-partners__swiper"
          >
            {clients.map((logo, index) => (
              <SwiperSlide key={index}>
                <div className="uniq-oglitz-partners__logo">
                  <img src={logo} alt="Client Logo" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Partners;
